import { QS_CONSTANT } from '../../define/global';

const productTypeConvTable = {
  'whale-space': QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_WHALE_SPACE,
  dropbox: QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_DROPBOX,
  'google-drive': QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_GOOGLE_DRIVE
};

export const selectCurrentProductFromPath = (path) => {
  //let productType = QS_CONSTANT.PRODUCT_TYPE.VALUES.STANDALONE;
  const productTypeInPath = path.split('/')[1];

  let productType =
    productTypeConvTable[productTypeInPath] || QS_CONSTANT.PRODUCT_TYPE.VALUES.STANDALONE;

  return productType;
};
